export const CONSTANTS = {
  ACCEPT: 'accept',
  REJECT: 'reject',
  CANCEL: 'cancel',
} as const;
